<script>
import ModalDialog from './ModalDialog.vue'
import ButtonAll from '../Button/ButtonAll.vue'
import mixinComponent from '../../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../../Mixins/global'

export default {
  components: { ButtonAll, ModalDialog },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    message: { type: String, required: false },
    title: { type: String, required: false },
    id: { type: String, default: '', required: false },
    param: { type: String, required: false },
    buttonConfirmTitle: { type: String, required: false },
    buttonCancelTitle: { type: String, required: false },
    loader: { type: Boolean, required: false, default: false },
  },
  emits: ['confirm', 'cancel'],
  data: function () {
    return {
      loading: false,
    }
  },
  computed: {
    paramDefined() {
      return this.param !== null && this.param !== undefined
    },
  },
  methods: {
    open() {
      this.showModal()
    },
    close() {
      this.closeModal()
    },
    showModal(message = null) {
      if (!!message) {
        this.message = message
      }
      this.$refs['confirm-modal' + this.id].open()
    },
    closeModal() {
      if (this.loader) {
        this.loading = false
      }
      this.$refs['confirm-modal' + this.id].close(false)
    },
    confirm() {
      if (this.loader) {
        this.loading = true
      }

      this.$emit('confirm', this.paramDefined ? this.param : true)
    },
    cancel() {
      this.$emit('cancel', this.paramDefined ? this.param : false)

      this.closeModal()
    },
  },
}
</script>
<template>
  <ModalDialog
    :id="'confirm-modal' + id"
    :ref="'confirm-modal' + id"
    class-modal-dialog="modal-lg"
    :title-t="message"
    class-header="d-flex justify-content-center align-items-center"
    e2e-modal="confirm"
    @icon-close="closeModal"
  >
    <template #body>
      <div class="d-flex justify-content-center">
        <p v-if="title" class="mt-2">{{ $t(title) }}</p>
      </div>
      <div class="d-flex justify-content-around py-3">
        <ButtonAll
          margin="no"
          type="success"
          :label="buttonConfirmTitle ?? 'modal.confirmation.confirm'"
          e2e-button="modalYes"
          :loading="loading"
          @click="confirm"
        />
        <ButtonAll
          margin="no"
          type="danger"
          :label="buttonCancelTitle ?? 'modal.confirmation.cancel'"
          e2e-button="modalNo"
          @click="cancel"
        />
      </div>
    </template>
  </ModalDialog>
</template>
